import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { Modal, ModalBody, Input } from 'reactstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { referFriend } from "../../../redux/actions/AccountAction";

const ListContactModal = ({
  openModal = false,
  onClosed,
  googleContacts,
  referFriend
}) => {
  const [modal, setModal] = useState(openModal);
  const [contacts, setContacts] = useState([]);
  const [displayContacts, setDisplayContacts] = useState(contacts);
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    if (googleContacts) {
      setContacts(googleContacts);
      setDisplayContacts(googleContacts);
    }
  }, [googleContacts]);

  useEffect(() => {
    setModal(openModal);
  }, [openModal]);

  const toggleModal = () => setModal(!modal);

  const onModalClosed = () => {
    setModal(false);
    onClosed();
  }

  const handleSearch = ({ target }) => {
    let filteredContact;
    const searchText = target.value;
    if (searchText) {
      filteredContact = contacts.filter(contact => {
        return (contact.email && contact.email.includes(searchText)) ||
          (contact.first_name && contact.first_name.includes(searchText)) ||
          (contact.last_name && contact.last_name.includes(searchText));
      });
    } else {
      filteredContact = contacts;
    }
    setDisplayContacts(filteredContact);
  }

  const changeSelection = (key) => ({ target }) => {
    if (target.checked) {
      setSelectedContacts([...selectedContacts, displayContacts[key]]);
    } else {
      const selected = [...selectedContacts];
      selected.splice(key, 1);
      setSelectedContacts(selected);
    }
  }

  const onSelectAll = ({ target }) => {
    if (target.checked) {
      setSelectedContacts(contacts);
    } else {
      setSelectedContacts([]);
    }
  };

  const sendRefer = () => {
    if (!selectedContacts.length) {
      toast.error('Please select contact from the list.');
      return;
    }
    setProcessing(true);
    referFriend({ refer_list: selectedContacts });
  };

  return (
    <Modal isOpen={modal} toggle={toggleModal} size="md" onClosed={onModalClosed}>
      <ModalBody>
        <div className="account-setup-modal">
          <div className="form-container">
            <div className="form-header mt-md-3 mt-0">
              <h2>INVITE FRIENDS</h2>
              <span>Invite friends to join MYRA</span>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="search_content">
                  <Input type="text" placeholder="Search Contacts" onChange={handleSearch} />
                  <FontAwesomeIcon icon={faSearch} />
                </div>
              </div>
            </div>
            <div className="contact-container">
              <ul className="contact-list">
                {
                  displayContacts.map((item, key) => {
                    return (
                      <li key={key}>
                        <input type="checkbox" onChange={changeSelection(key)} />
                        <div className="contact-details">
                          <span className="title">
                            {item.first_name || item.last_name ? `${item.first_name} ${item.last_name}` : item.email}
                          </span>
                          <span className="email">{item.email}</span>
                        </div>
                      </li>
                    );
                  })
                }
              </ul>
            </div>
            <div className="row align-items-center">
              <div className="col-sm-4">
                <input type="checkbox" onChange={onSelectAll} /> SELECT ALL
              </div>
              <div className="col-sm-8">
                <button className="custom-btn-primary" type="button" onClick={sendRefer} disabled={processing}>
                  {selectedContacts.length ? `SEND ${selectedContacts.length} INVITES` : 'SEND INVITES'}
                  {processing && <FontAwesomeIcon icon={faSpinner} />}
                </button>
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  )
};

const mapStateToProps = state => ({
  googleContacts: state.Account.googleContacts,
});

const mapDispatchToProps = dispatch => ({
  referFriend: payload => {
    dispatch(referFriend(payload))
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListContactModal);
